import { attr, html, Value } from '@tempots/dom'

export type LogoOptions = {
  size: Value<'header' | 'main'>
  mode?: Value<'light' | 'dark'>
}

export function Logo({ size, mode = 'light' }: LogoOptions) {
  return html.div(
    attr.class('flex items-center gap-2'),
    html.img(
      attr.class(
        Value.map(size, (size): string =>
          size === 'main' ? 'h-20 sm:h-24 md:h-26' : 'h-10 sm:h-12 md:h-14'
        )
      ),
      attr.src(
        Value.map(mode, (mode): string =>
          mode === 'light' ? '/logo.svg' : '/logo-dark.svg'
        )
      )
    ),
    html.div(attr.class('hidden'), 'ResumeHeaders')
  )
}
